"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatStatelessMessage = exports.parseStatelessMessage = void 0;
function parseStatelessMessage(payload) {
    const [type, value] = payload.split('|');
    switch (type) {
        case 'saved':
            return { type: 'saved', value };
        case 'savedHashes':
            return { type: 'savedHashes', value: JSON.parse(value) };
        case 'potentialError':
            return { type: 'potentialError' };
        default:
            throw new Error('Invalid message type');
    }
}
exports.parseStatelessMessage = parseStatelessMessage;
function formatStatelessMessage(message) {
    switch (message.type) {
        case 'saved':
            return `saved|${message.value}`;
        case 'savedHashes':
            return `savedHashes|${JSON.stringify(message.value)}`;
        case 'potentialError':
            return 'potentialError';
    }
}
exports.formatStatelessMessage = formatStatelessMessage;
//# sourceMappingURL=stateless-messaging.js.map